// Custom JavaScript for L'AUBE BLANC
// Add custom scripts here. Do not modify theme.js directly.

/* CUSTOM:LB — チャネルトークのランチャーをモバイルドックに追従させる。
   背景：CSS だと ChannelTalk が当てるインラインstyle(transform) に負けて効かず、
   さらにランチャーは遅延生成されるため、JS で直接インラインに上書きする。
   挙動：
     ・ドック(.lb-dock)が表示中(.is-hidden でない)＆モバイル幅のときだけ、
       ランチャーをドック高さ(約3.75rem + セーフエリア)ぶん上へずらす。
     ・ドックが隠れたら元に戻す（ドックと同じ 0.25s ease で連動）。
   実装メモ：
     ・ランチャーは遅延生成 → 出現するまでポーリングで探す（open shadow DOM も探索）。
     ・ChannelTalk が style を上書きしても、style 監視で再適用する。
     ・既存 transform があれば壊さないよう、自分の translate を「合成」して付与する。
     ・ずらす対象は内側のアイコン(#ch-plugin-launcher)ではなく、ビューポートに固定
       されている親ラッパー（position:fixed の最外祖先）。内側だけ動かすと親の
       ヒット領域が元位置に残り、モバイルドックのハンバーガーを覆ってクリックを奪う。 */
(function () {
  var DOCK_SELECTOR = '.lb-dock';
  var LAUNCHER_SELECTORS = ['#ch-plugin-launcher', '.kIAbJl'];
  var SHIFT = 'translateY(calc(-3.75rem - env(safe-area-inset-bottom)))';
  var mobileMq = window.matchMedia('(max-width: 699px)');
  var launcher = null;
  var target = null; // 実際に transform を当てる要素（固定配置の親ラッパー）

  // ランチャーを light DOM → open shadow DOM の順で探す
  function findLauncher(root) {
    root = root || document;
    for (var i = 0; i < LAUNCHER_SELECTORS.length; i++) {
      var el = root.querySelector(LAUNCHER_SELECTORS[i]);
      if (el) return el;
    }
    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      if (all[j].shadowRoot) {
        var found = findLauncher(all[j].shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  // ランチャーから上に辿り、ビューポートに固定されている最外祖先を返す。
  // これがヒット領域を持つラッパー。見つからなければランチャー自身を返す。
  function getShiftTarget(el) {
    var node = el;
    var fixed = el;
    while (node && node !== document.body && node.nodeType === 1) {
      if (getComputedStyle(node).position === 'fixed') fixed = node;
      node = node.parentElement;
    }
    return fixed;
  }

  function isDockVisible() {
    if (!mobileMq.matches) return false;
    var dock = document.querySelector(DOCK_SELECTOR);
    if (!dock || dock.classList.contains('is-hidden')) return false;
    return getComputedStyle(dock).display !== 'none';
  }

  // 自分の SHIFT を取り除いた「ChannelTalk 本来の transform」を返す
  function baseTransform() {
    var t = target.style.getPropertyValue('transform') || '';
    return t.replace(SHIFT, '').trim();
  }

  function applyShift() {
    if (!target || !target.isConnected) return;
    var current = target.style.getPropertyValue('transform') || '';
    var base = baseTransform();
    if (isDockVisible()) {
      var want = (base ? base + ' ' : '') + SHIFT;
      if (current !== want) {
        target.style.setProperty('transition', 'transform 0.25s ease', 'important');
        target.style.setProperty('transform', want, 'important');
      }
    } else if (current !== base) {
      if (base) {
        target.style.setProperty('transform', base, 'important');
      } else {
        target.style.removeProperty('transform');
      }
    }
  }

  function onLauncherFound() {
    // ヒット領域を持つ固定配置の親ラッパーを実ターゲットにする
    target = getShiftTarget(launcher);
    // ChannelTalk が style を書き換えても追従できるよう監視（ガードで無限ループ防止）
    new MutationObserver(applyShift).observe(target, {
      attributes: true,
      attributeFilter: ['style']
    });
    applyShift();
  }

  // ドックの表示状態(class)変化に追従
  var dock = document.querySelector(DOCK_SELECTOR);
  if (dock) {
    new MutationObserver(applyShift).observe(dock, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // 画面幅変更にも対応
  if (mobileMq.addEventListener) {
    mobileMq.addEventListener('change', applyShift);
  } else if (mobileMq.addListener) {
    mobileMq.addListener(applyShift);
  }

  // ランチャーは遅延生成されるので、見つかるまでポーリング（最大 ~20 秒）
  launcher = findLauncher();
  if (launcher) {
    onLauncherFound();
  } else {
    var tries = 0;
    var poll = setInterval(function () {
      launcher = findLauncher();
      if (launcher) {
        clearInterval(poll);
        onLauncherFound();
      } else if (++tries > 40) {
        clearInterval(poll);
      }
    }, 500);
  }
})();
